import React, {Component} from "react";
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {RemoveQcStates} from "./types/RemoveQcOfferTypes";
import withAuth from "../../hoc/withAuth";
import {Button, Card, Col, Form, Input, Modal, Row} from "antd";
import Cookies from "universal-cookie";
import {offerApiServices} from "../../services/offer/OfferApiService";

export interface RemoveQcProps {
}

class RemoveQcOffer extends Component<RemoveQcProps & any, RemoveQcStates> {
    private readonly initState!: RemoveQcStates;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private token = new Cookies().get("_t");

    constructor(props: (RemoveQcProps & any) | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
            offerCode: "",
            fetchProcess: false,
            showFormRemoveQc: false,
            removeQcProcess: false,
            dataOrder: {},
            removeQcOfferModal: false,
            companyCode: companyCode
        };
        this.state = {...this.initState};
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value,
            offerCode: "",
            fetchProcess: false,
            showFormRemoveQc: false,
            removeQcProcess: false,
            dataOrder: {},
            removeQcOfferModal: false,
        });
    };

    removeQcOffer = async () => {
        await this.promisedSetState({
            removeQcOfferModal: true,
        });
    };

    closeModalCancel = async () => {
        await this.promisedSetState({
            removeQcOfferModal: false,
        });
    };

    triggerRemoveQcOffer = async () => {
        await this.promisedSetState({
            removeQcProcess: true,
        });

        try {
            await offerApiServices.setToken(this.token);
            await offerApiServices
                .removeQcOffer({
                    update_type: "remove-qc-offer",
                    company: this.state.companyCode,
                    offer_code: this.state.offerCode,
                    admin_id: this.user,
                    admin_name: this.user,
                })
                .then((successData) => {
                    Modal.success({
                        title: "Proses Sukses",
                        content: "QC Offer berhasil di Hapus ",
                    });
                    this.closeModalCancel();
                    this.defaultState();
                });
        } catch (e) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda " + e,
            });
            await this.promisedSetState({
                removeQcProcess: false,
            });
        }
    };

    defaultState = async () => {
        await this.promisedSetState({
            fetchProcess: false,
            showFormRemoveQc: false,
            removeQcProcess: false,
            dataOrder: {},
            removeQcOfferModal: false,
        });
    };

    onFieldChange = <T extends keyof Pick<any, "offerCode">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "offerCode":
                currentState.offerCode = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout
                    noPadNoMar={true}
                    onChangeDealer={this.onDealerChange}
                    breadcrumbPath={`Offer`}
                    breadcrumbMenu={`Cancel QC Offer`}
                    defaultSelectedKeys={["m-remove-qc-offer"]}
                    defaultOpenKeys={["sm-sm-sys-offer", "sm-offer"]}
                >
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <div style={{padding: 20}}>
                        <Row>
                            <Col xs={24} xl={8}>
                                <Card title="Cancel QC Offer" style={{margin: 10}}>
                                    <Form layout="vertical">
                                        <Form.Item label="Kode Offer">
                                            <Input value={this.state.offerCode} disabled={this.state.showFormRemoveQc} placeholder="Kode Offer" onChange={(event) => this.onFieldChange("offerCode", event.target.value)}/>
                                        </Form.Item>
                                        <br/>
                                        <Button type={"primary"} loading={this.state.fetchProcess} onClick={() => this.removeQcOffer()}>
                                            {" "}
                                            Cancel Qc Offer
                                        </Button>
                                        {/* <Button type={"primary"} loading={this.state.fetchProcess} onClick={() => this.getDataOffer()}>
                      {" "}
                      Get Data Offer
                    </Button> */}
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal
                        visible={this.state.removeQcOfferModal}
                        title="Konfirmasi Cancel QC OFFER"
                        onCancel={this.closeModalCancel}
                        cancelText={"Tutup"}
                        okText={false}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button type={"primary"} loading={this.state.removeQcProcess} key="1" onClick={this.triggerRemoveQcOffer}>
                                Yakin
                            </Button>,
                            <Button loading={this.state.removeQcProcess} key="2" onClick={this.closeModalCancel}>
                                Kembali
                            </Button>,
                        ]}
                    >
                        Anda Yakin Akan Melakukan <b>Cancel QC</b> Offer ? <br/>
                        <br/>
                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default withAuth(withRouter(RemoveQcOffer), 45);
